import { useEffect, useState } from "react";

import { Image } from "simplydo/react/ui";

type ImageWithFallbackProps = {
  fallbackSrc?: string;
  fallbackElement?: React.ReactNode;
} & React.ComponentProps<typeof Image>;

export const ImageWithFallback = ({
  fallbackSrc,
  fallbackElement,
  src,
  alt,
  ...props
}: ImageWithFallbackProps) => {
  const [didError, setDidError] = useState(false);
  const [originalSrc, setOriginalSrc] = useState(src);
  const [safeSrc, setSafeSrc] = useState(src);

  useEffect(() => {
    if (src !== originalSrc) {
      setSafeSrc(src);
      setOriginalSrc(src);
      setDidError(false);
    }
  }, [originalSrc, src]);

  if (!src || (didError && fallbackElement)) {
    return fallbackElement;
  }

  return (
    <Image
      src={safeSrc}
      onError={() => {
        if (fallbackSrc !== safeSrc && fallbackSrc) {
          setSafeSrc(fallbackSrc);
        } else {
          setDidError(true);
        }
      }}
      {...props}
    />
  );
};
